/* global alert, FileReader */
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'preview', 'currentLogo', 'newPreview', 'removeButton']

  connect () {
    this.hasNewFile = false
  }

  preview (event) {
    const file = event.target.files[0]

    if (!file) {
      this.clearPreview()
      return
    }

    if (!file.type.startsWith('image/')) {
      alert('Пожалуйста, выберите изображение')
      this.inputTarget.value = ''
      return
    }

    const reader = new FileReader()
    reader.onload = (e) => {
      this.showPreview(e.target.result, file.name)
    }
    reader.readAsDataURL(file)
  }

  showPreview (src, filename) {
    this.hasNewFile = true

    // Hide current logo if exists
    if (this.hasCurrentLogoTarget) {
      this.currentLogoTarget.style.display = 'none'
    }

    // Show new preview
    this.newPreviewTarget.innerHTML = `
      <p class="admin-form__hint" style="margin-bottom: 8px;">Новый логотип (не сохранён):</p>
      <div style="position: relative; display: inline-block;">
        <img src="${src}"
             alt="Превью логотипа"
             style="height: 80px; width: auto; object-fit: contain; border: 2px solid var(--admin-primary); border-radius: var(--admin-radius-md); padding: 8px;" />
        <span style="position: absolute; top: -8px; right: -8px; background: var(--admin-primary); color: white; font-size: 10px; padding: 2px 6px; border-radius: 10px;">
          Новый
        </span>
      </div>
      <p style="font-size: 12px; color: var(--admin-text-muted); margin-top: 4px;">${filename}</p>
    `
    this.newPreviewTarget.style.display = 'block'

    // Show remove button
    if (this.hasRemoveButtonTarget) {
      this.removeButtonTarget.style.display = 'inline-flex'
    }
  }

  clearPreview () {
    this.hasNewFile = false
    this.inputTarget.value = ''

    // Hide new preview
    this.newPreviewTarget.innerHTML = ''
    this.newPreviewTarget.style.display = 'none'

    // Show current logo if exists
    if (this.hasCurrentLogoTarget) {
      this.currentLogoTarget.style.display = 'block'
    }

    // Hide remove button
    if (this.hasRemoveButtonTarget) {
      this.removeButtonTarget.style.display = 'none'
    }
  }

  remove (event) {
    event.preventDefault()
    this.clearPreview()
  }
}
